import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SiteShell from "../components/site/SiteShell";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to="/portal" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back.");
      navigate("/portal");
    } else {
      setError(res.error || "Login failed");
    }
  };

  return (
    <SiteShell>
      <section className="min-h-[80vh] flex items-center py-20" data-testid="login-section">
        <div className="max-w-[480px] w-full mx-auto px-6">
          <div className="kicker mb-5">Client Portal</div>
          <h1 className="h-display text-white text-[40px] sm:text-[56px] mb-10">
            LOG <span className="text-[#d4af37]">IN.</span>
          </h1>

          <form onSubmit={submit} className="space-y-7" data-testid="login-form">
            <label className="block">
              <span className="kicker mb-2 block">Email</span>
              <input
                type="email"
                className="lux-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@rae-enterprise.com"
                data-testid="login-email-input"
                autoFocus
              />
            </label>
            <label className="block">
              <span className="kicker mb-2 block">Password</span>
              <input
                type="password"
                className="lux-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="login-password-input"
              />
            </label>

            {error && (
              <div className="text-[13px] text-red-400 border border-red-500/30 px-3 py-2" data-testid="login-error">
                {error}
              </div>
            )}

            <button type="submit" disabled={busy} className="btn-gold btn-label w-full justify-center disabled:opacity-60" data-testid="login-submit-btn">
              {busy ? "Signing in…" : "Sign In"} <ArrowRight size={16} strokeWidth={1.6} />
            </button>
          </form>
        </div>
      </section>
    </SiteShell>
  );
}
